import { http } from "@next-core/http";
/**
 * @description 获取协作空间内的服务对象列表
 * @endpoint list /api/v1/elevo/workspaces/:workspaceId/service-objects
 */
export const ElevoObjectApi_listServiceObjects = async (workspaceId, params, options) => /**! @contract easyops.api.llm.elevo_object.ListServiceObjects@1.0.0 */(await http.get(`api/gateway/logic.llm.aiops_service/api/v1/elevo/workspaces/${workspaceId}/service-objects`, {
  ...options,
  params
})).data;
//# sourceMappingURL=listServiceObjects.js.map